import { render, staticRenderFns } from "./CreateAvatar.vue?vue&type=template&id=86993f44"
import script from "./CreateAvatar.vue?vue&type=script&lang=js"
export * from "./CreateAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports